module.exports = __webpack_public_path__ + "static/media/ArrowRight.99cf29db.svg";